var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPostShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.7593 2.24059C17.6021 2.0835 17.4059 1.97116 17.1909 1.91514C16.9758 1.85911 16.7497 1.86142 16.5359 1.92184H16.5242L1.52884 6.47184C1.2854 6.542 1.06903 6.68447 0.908388 6.88039C0.747752 7.0763 0.650437 7.3164 0.629342 7.56887C0.608246 7.82134 0.664365 8.07426 0.790262 8.29411C0.916158 8.51397 1.10589 8.69038 1.33431 8.79996L7.96869 12.0312L11.1952 18.6617C11.2956 18.8758 11.4552 19.0568 11.6551 19.1832C11.855 19.3096 12.0869 19.3761 12.3234 19.375C12.3593 19.375 12.3952 19.3734 12.4312 19.3703C12.6835 19.3498 12.9234 19.2528 13.1189 19.092C13.3144 18.9313 13.4561 18.7146 13.5249 18.4711L18.0718 3.47574C18.0718 3.47184 18.0718 3.46793 18.0718 3.46403C18.133 3.25072 18.1363 3.02496 18.0814 2.80995C18.0265 2.59493 17.9153 2.39842 17.7593 2.24059ZM12.3304 18.1132L12.3265 18.1242V18.1187L9.19681 11.689L12.9468 7.93903C13.0591 7.82086 13.1207 7.66352 13.1186 7.50054C13.1166 7.33757 13.0509 7.18185 12.9356 7.0666C12.8204 6.95135 12.6647 6.88568 12.5017 6.88359C12.3387 6.88151 12.1814 6.94317 12.0632 7.05543L8.31322 10.8054L1.88119 7.67574H1.87572H1.88665L16.8749 3.12496L12.3304 18.1132Z",
    fill: "#424242"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPostShare);
export default __webpack_public_path__ + "static/media/icon_post_share.d499c731fe00006333496703ba0071ed.svg";
export { ForwardRef as ReactComponent };